import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { ILoginResponseViewModel } from '../../../UserService/Api';

/**
 * Authentication API (`/auth/*`).
 * Matches legacy `transcepta-thunks/UserThunk.refreshLoginToken` (POST form body to `/auth/login`).
 */
export class AuthApi {
    private route = '/auth';

    /**
     * POST `/auth/login` with `grant_type=refresh_token` to obtain a new access token.
     * Same contract as `UserThunk.refreshLoginToken` (form-urlencoded body).
     */
    public postLoginWithRefreshToken = (refreshToken: string): ApiResponse<ILoginResponseViewModel> => {
        const body = `grant_type=refresh_token&refresh_token=${refreshToken}`;

        return api().post(`${this.route}/login`, body);
    };
}
